<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.03846 9.96154C3.03846 6.13803 6.13803 3.03846 9.96154 3.03846C13.785 3.03846 16.8846 6.13803 16.8846 9.96154C16.8846 11.8735 16.1106 13.6032 14.8569 14.8569C14.8411 14.8727 14.8252 14.8884 14.8093 14.9041C14.3361 12.5871 12.2865 10.844 9.82975 10.844C7.45106 10.844 5.45409 12.4781 4.90007 14.685C3.74522 13.448 3.03846 11.7873 3.03846 9.96154ZM9.96154 1.5C5.28836 1.5 1.5 5.28836 1.5 9.96154C1.5 14.6347 5.28836 18.4231 9.96154 18.4231C12.0208 18.4231 13.9093 17.6866 15.3762 16.464L20.1868 21.2747C20.4872 21.5751 20.9743 21.5751 21.2747 21.2747C21.5751 20.9743 21.5751 20.4872 21.2747 20.1868L16.464 15.3762C17.6866 13.9093 18.4231 12.0208 18.4231 9.96154C18.4231 5.28836 14.6347 1.5 9.96154 1.5ZM9.82975 4.37552C8.29869 4.37552 7.05753 5.61668 7.05753 7.14773C7.05753 8.67879 8.29869 9.91995 9.82975 9.91995C11.3608 9.91995 12.602 8.67879 12.602 7.14773C12.602 5.61668 11.3608 4.37552 9.82975 4.37552Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgLookupPeople',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>